import { __extends } from "tslib";
// eslint-disable-next-line import/no-extraneous-dependencies
import lottie from 'lottie-web';
import React from 'react';
var LottieAnimation = /** @class */ (function (_super) {
    __extends(LottieAnimation, _super);
    function LottieAnimation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = React.createRef();
        return _this;
    }
    LottieAnimation.prototype.componentDidMount = function () {
        this.animation = lottie.loadAnimation({
            container: this.element.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: this.props.path,
        });
    };
    LottieAnimation.prototype.componentWillUnmount = function () {
        this.animation.destroy();
    };
    LottieAnimation.prototype.render = function () {
        var _a = this.props, width = _a.width, height = _a.height;
        return React.createElement("div", { ref: this.element, style: { width: width, height: height } });
    };
    return LottieAnimation;
}(React.Component));
export { LottieAnimation };
//# sourceMappingURL=index.js.map